const modules = {
	versionDisplay: "versionDisplay",
	accordionComponent: "accordion",
	backToTopButtonComponent: "backToTopButton",
	breadcrumbComponent: "breadcrumb",
	checkboxComponent: "checkbox",
	datepickerComponent: "datepicker",
	downloadsComponent: "downloads",
	fileUploadComponent: "file-upload",
	formComponent: "form",
	formRepeatable: "form-repeatable",
	galleryComponent: "gallery",
	handlePagination: "handlePagination",
	headerComponent: "header",
	hamburgerComponent: "hamburger",
	inputFieldComponent: "input",
	newsCategoriesComponent: "news-categories",
	newsFilterComponent: "news-filter",
	lightboxComponent: "lightboxComponent",
	logoSliderComponent: "logoSlider",
	multiselectComponent: "multiselect",
	overlayComponent: "overlay",
	radiofieldComponent: "radiofield",
	selectComponent: "select",
	searchOverlayComponent: "search-overlay",
	searchresultFilterComponent: "searchresult-filter",
	sliderContainerComponent: "sliderContainer",
	tabsComponent: "tabs",
	videoTabsComponent: "video-tabs",
	teaserLogoComponent: "teaser-logo",
	videoYoutubeComponent: "video-youtube",
	videoPolyvComponent: "video-polyv",
}

const loadedModules = {}

class DynamicModuleLoader {
	/**
	 * get the list of dynamic Modules
	 * @returns object
	 */
	get modules() {
		return modules
	}

	/**
	 * use webpack dynamic imports
	 * @param componentName {string}
	 * @param callback {function}
	 * @private
	 */
	_import(componentName, callback) {
		if (typeof componentName === "string" && typeof callback === "function") {
			let modulePromise

			switch (componentName) {
				case modules.versionDisplay:
					modulePromise = import(/* webpackChunkName: "versionDisplay" */ "../components/VersionDisplay.js")
					break
				case modules.accordionComponent:
					modulePromise = import(
						/* webpackChunkName: "accordion" */ "../../components/accordion/accordion.js"
					)
					break
				case modules.backToTopButtonComponent:
					modulePromise = import(
						/* webpackChunkName: "backToTopButton" */ "../../components/back-to-top-button/back-to-top-button.js"
					)
					break
				case modules.breadcrumbComponent:
					modulePromise = import(
						/* webpackChunkName: "breadcrumb" */ "../../components/breadcrumb/breadcrumb.js"
					)
					break
				case modules.checkboxComponent:
					modulePromise = import(/* webpackChunkName: "checkbox" */ "../../components/checkbox/checkbox.js")
					break
				case modules.datepickerComponent:
					modulePromise = import(
						/* webpackChunkName: "datepicker" */ "../../components/datepicker/datepicker.js"
					)
					break
				case modules.downloadsComponent:
					modulePromise = import(
						/* webpackChunkName: "downloads" */ "../../components/downloads/downloads.js"
					)
					break
				case modules.fileUploadComponent:
					modulePromise = import(
						/* webpackChunkName: "fileUpload" */ "../../components/file-upload/file-upload.js"
					)
					break
				case modules.formComponent:
					modulePromise = import(/* webpackChunkName: "form" */ "../../components/form/form.js")
					break
				case modules.formRepeatable:
					modulePromise = import(
						/* webpackChunkName: "form-repeatable" */ "../../components/form-repeatable/form-repeatable.js"
					)
					break
				case modules.galleryComponent:
					modulePromise = import(/* webpackChunkName: "gallery" */ "../../components/gallery/gallery.js")
					break
				case modules.handlePagination:
					modulePromise = import(/* webpackChunkName: "handle-pagination" */ "../utils/HandlePagination.js")
					break
				case modules.headerComponent:
					modulePromise = import(/* webpackChunkName: "header" */ "../../components/header/header.js")
					break
				case modules.hamburgerComponent:
					modulePromise = import(
						/* webpackChunkName: "hamburger" */ "../../components/hamburger/hamburger.js"
					)
					break
				case modules.inputFieldComponent:
					modulePromise = import(
						/* webpackChunkName: "input-field" */ "../../components/inputfield/inputfield.js"
					)
					break
				case modules.newsCategoriesComponent:
					modulePromise = import(
						/* webpackChunkName: "news-categories" */ "../../components/news-categories/news-categories.js"
					)
					break
				case modules.newsFilterComponent:
					modulePromise = import(
						/* webpackChunkName: "news-filter" */ "../../components/news-filter/news-filter.js"
					)
					break
				case modules.lightboxComponent:
					modulePromise = import(/* webpackChunkName: "lightbox" */ "../components/Lightbox.js")
					break
				case modules.logoSliderComponent:
					modulePromise = import(
						/* webpackChunkName: "logoSlider" */ "../../components/logo-slider/logo-slider.js"
					)
					break
				case modules.multiselectComponent:
					modulePromise = import(
						/* webpackChunkName: "multiselect" */ "../../components/multiselect/multiselect.js"
					)
					break
				case modules.overlayComponent:
					modulePromise = import(/* webpackChunkName: "overlay" */ "../../components/overlay/overlay.js")
					break
				case modules.radiofieldComponent:
					modulePromise = import(
						/* webpackChunkName: "radiofield" */ "../../components/radiofield/radiofield.js"
					)
					break
				case modules.selectComponent:
					modulePromise = import(/* webpackChunkName: "select" */ "../../components/select/select.js")
					break
				case modules.searchOverlayComponent:
					modulePromise = import(
						/* webpackChunkName: "search-overlay" */ "../../components/search-overlay/search-overlay.js"
					)
					break
				case modules.searchresultFilterComponent:
					modulePromise = import(
						/* webpackChunkName: "searchresult-filter" */ "../../components/searchresult-filter/searchresult-filter.js"
					)
					break
				case modules.sliderContainerComponent:
					modulePromise = import(
						/* webpackChunkName: "slider-container" */ "../../components/slider-container/slider-container.js"
					)
					break
				case modules.tabsComponent:
					modulePromise = import(/* webpackChunkName: "tabs" */ "../../components/tabs/tabs.js")
					break
				case modules.teaserLogoComponent:
					modulePromise = import(/* webpackChunkName: "teaser-logo" */ "../../components/teaser-logo/teaser-logo.js")
					break
				case modules.videoTabsComponent:
					modulePromise = import(
						/* webpackChunkName: "video-tabs" */ "../../components/video-tabs/video-tabs.js"
					)
					break
				case modules.videoYoutubeComponent:
					modulePromise = import(
						/* webpackChunkName: "video-youtube" */ "../../components/video/video-youtube.js"
					)
					break
				case modules.videoPolyvComponent:
					modulePromise = import(
						/* webpackChunkName: "video-polyv" */ "../../components/video/video-polyv.js"
					)
					break
				default:
					// eslint-disable-next-line no-console
					console.warn("Module not found")
					break
			}

			modulePromise.then((component) => {
				callback(component.default)
			})
		}
	}

	/**
	 * Dynamically Module Loader
	 * @param condition {boolean}
	 * @param componentName {string}
	 * @param onLoadComponent {function}
	 */
	load(condition, componentName, onLoadComponent = undefined) {
		if (condition) {
			if (!loadedModules[componentName]) {
				this._import(componentName, (Component) => {
					if (typeof onLoadComponent === "function") {
						onLoadComponent(Component)
					} else {
						new Component()
					}
					loadedModules[componentName] = Component
				})
			} else {
				if (typeof onLoadComponent === "function") {
					onLoadComponent(loadedModules[componentName])
				}
			}
		}
	}
}

export default new DynamicModuleLoader()
